import { render, staticRenderFns } from "./Episode4.vue?vue&type=template&id=44553899&"
import script from "./Episode4.vue?vue&type=script&lang=js&"
export * from "./Episode4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports